export default __webpack_public_path__ + "0a3ebf5c7031dd13f879a86890d8bd15.png";